
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Image,
  message,
  Row,
  Space,
  Switch,
  Tag,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import PhysioSessionsOp from "./PhysioSessionsOp";
import dayjs from "dayjs";
import calendarImg from "../../../../assets/images/nurseIcons/calender.svg";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import { LeftOutlined, RightOutlined, PlusOutlined } from "@ant-design/icons";
import {
  getSessionsAPI,
  updatePhysioCareAPI,
} from "../../../../services/outpatient.services";
import useQuery from "../../../../hooks/useQuery";
import "./PhysioSessionsOp.css";

const dateFormat = "MMM DD, YYYY";

const PhysioCareOp = ({ patientData, refreshPage }) => {
  const params = useQuery();
  const admissionID = params?.aid;
  const curDate = dayjs().format(dateFormat);
  const [physioRefresh, setPhysioRefresh] = useState(false);
  const [date, setDate] = useState(curDate);
  const [sessions, setSessions] = useState([]);
  const [isCreateSessionOpen, setIsCreateSessionOpen] = useState(false);
  const [createSessionNumber, setCreateSessionNumber] = useState(null);
  const [activeKey, setActiveKey] = useState(null);
  const serviceFromPackage = params?.pkg_service;

  const fetchSessions = async () => {
    try {
      const res = await getSessionsAPI(admissionID);
      const list = Array.isArray(res?.data) ? res.data : res?.data?.data || [];
      const sorted = [...list].sort((a, b) => {
        const sa = Number(a?.session);
        const sb = Number(b?.session);
        if (Number.isFinite(sa) && Number.isFinite(sb)) return sb - sa;
        const da = a?.session_date ? new Date(a.session_date).getTime() : 0;
        const db = b?.session_date ? new Date(b.session_date).getTime() : 0;
        return db - da;
      });
      setSessions(sorted);
    } catch (err) {
      console.log(err);
      message.error(
        err?.response?.data?.message || "Failed to fetch sessions."
      );
      setSessions([]);
    }
  };

  useEffect(() => {
    if (admissionID) fetchSessions();
  }, [admissionID]);

  const refreshTables = () => {
    setPhysioRefresh((prev) => !prev);
  };
  useEffect(() => {
    if (serviceFromPackage && sessions.length > 0) {
      const match = sessions.find((s) => s.service_name === serviceFromPackage);
      if (match?.id != null) {
        setActiveKey(String(match.id));
      }
    }
  }, [serviceFromPackage, sessions]);

  const disabledDate = (current) => current && current > dayjs().endOf("day");

  const onDateChange = (date, dateString) => {
    setDate(date ? dateString : null);
  };

  // const handleAddSession = () => {
  //   // setSessions((prev) => [...prev, { id: prev.length + 1 }]);
  // };

  // derive facility id from patientData (try common keys)
  const facilityID =
    patientData?.facility_id || patientData?.facility || undefined;

  const handleShareToPatient = async (id, checked) => {
    try {
      const currentActive = activeKey;
      await updatePhysioCareAPI(id, { share_to_patient: checked });
      message.success("Session updated to patient");
      fetchSessions();
      setActiveKey(currentActive);
    } catch (err) {
      console.log(err);
      message.error("Failed to share session to patient.");
    }
  };

  return (
    <Row gutter={[0, 16]} className="op-physio-care-root">
      <Col span={24} className="flex-center"style={{marginTop: window.innerWidth <= 768 ? "16px" : "0px"}}>
        <Button
          type="dashed"
          className="mobile-fullwidth-btn"
          onClick={() => {
            if (
              sessions?.length == 0 ||
              (sessions?.[0]?.therapies && sessions?.[0]?.therapies?.length > 0)
            ) {
              setCreateSessionNumber(
  sessions.length > 0
    ? Number(sessions?.[0]?.session || sessions.length) + 1
    : 1
);

              setIsCreateSessionOpen(true);
            } else {
              message.error("Please add therapies to the current session.");
            }
          }}
          icon={<PlusOutlined />}
        >
          Create Session
        </Button>
      </Col>
      {/* <Col span={12} className="flex-end">
        <Space>
          <Button
            onClick={() =>
              setDate((prev) =>
                dayjs(prev).subtract(1, "day").format(dateFormat)
              )
            }
            icon={<LeftOutlined />}
          />
          <DatePicker
            style={{
              color: "black",
              border: "1px solid #a182e3",
              height: "38px",
              width: "150px",
            }}
            value={dayjs(date)}
            disabledDate={disabledDate}
            className={inputStyles.mdDateInput}
            onChange={onDateChange}
            allowClear={false}
            suffixIcon={<Image width={20} src={calendarImg} preview={false} />}
          />
          <Button
            onClick={() =>
              setDate((prev) => dayjs(prev).add(1, "day").format(dateFormat))
            }
            icon={<RightOutlined />}
          />
        </Space>
      </Col> */}

      <Col span={24} className="op">
      <div className="op-physio-care-sessions">
  <Collapse
    accordion
    activeKey={activeKey}
    onChange={(key) => setActiveKey(key || null)}
  >
    {sessions.length > 0 ? (
      sessions.map((session, index) => (
        <Collapse.Panel
          header={
  <div className="session-header">
    <div className="session-header-left">
      <Typography className="session-title">
        {"Session " + (session?.session ?? sessions.length - index)}
      </Typography>

      {session?.service_name && (
        <Tag color="green">{session?.service_name}</Tag>
      )}

      <Tag color="geekblue">
        {dayjs(session?.session_date).format(dateFormat)}
      </Tag>
    </div>

   <div className="session-header-share">
     <Space size={12}>
       <Typography.Text>Share to patient</Typography.Text>
       <Switch
         checked={session?.share_to_patient}
         onChange={(checked) =>
           handleShareToPatient(session?.id, checked)
         }
       />
     </Space>
   </div>


  </div>
}
          key={String(session?.id ?? index)}
        >
          <PhysioSessionsOp
            key={session.id}
            sessionNumber={sessions.length - index}
            patientData={patientData}
            date={date}
            physioRefresh={physioRefresh}
            refreshTables={refreshTables}
            refreshPage={refreshPage}
            facilityID={facilityID}
            createSession={false}
            setCreateSession={setIsCreateSessionOpen}
            fetchSessions={fetchSessions}
            sessionData={session || { therapies: [] }}
          />
        </Collapse.Panel>
      ))
    ) : (
      <div
        style={{
          textAlign: "center",
          padding: "20px 0",
          color: "#888",
          fontStyle: "italic",
        }}
      >
        No sessions yet. Click “Create Session” to add one.
      </div>
    )}
  </Collapse>
  </div>
  {isCreateSessionOpen && (
  <PhysioSessionsOp
    key="create-session-modal"
    sessionNumber={createSessionNumber || 1}
    patientData={patientData}
    date={date}
    physioRefresh={physioRefresh}
    refreshTables={refreshTables}
    refreshPage={refreshPage}
    facilityID={facilityID}
    createSession={isCreateSessionOpen}
    setCreateSession={setIsCreateSessionOpen}
    fetchSessions={fetchSessions}
    sessionData={{ therapies: [] }} 
  />
  )}
</Col>
<div className="mobile-create-session">
  <Button
    type="default"
    block
    icon={<PlusOutlined />}
    className="mobile-create-session-btn"
    onClick={() => {
      if (
        sessions?.length === 0 ||
        (sessions?.[0]?.therapies && sessions?.[0]?.therapies?.length > 0)
      ) {
        setCreateSessionNumber(
          sessions.length > 0
            ? Number(sessions?.[0]?.session || sessions.length) + 1
            : 1
        );
        setIsCreateSessionOpen(true);
      } else {
        message.error("Please add therapies to the current session.");
      }
    }}
  >
    Create Session
  </Button>
</div>
    </Row>
  );
};
export default PhysioCareOp;
     